module.exports = __webpack_public_path__ + "media/newstyle/images/logo-authorfreely-mobile-8fc3517bf4a6d3a5ca34f20fe483841d.png";